let shoplink = document.querySelector(".header__menu-item-shop");
let headerwrapper = document.querySelector(".header-wrapper");

let link_w_drodown_shop = document.querySelector(".link_w_drodown_shop");

let nav_open = document.querySelector("details[open]");
let ebikelink = document.querySelector(".megamenu_link_e-bikes a");
let escooterlink = document.querySelector(".megamenu_link_e-scooters a");
let bikeshoplink = document.querySelector(".megamenu_link_bike-shop a");
let merchlink = document.querySelector(".megamenu_link_merch a");

// let navLinks = document.querySelector(".header__submenu > li > a");

let ebikemenu = document.querySelector(".megamenu_image_ebikes"); 
let escootermenu = document.querySelector(".megamenu_image_escooters"); 
let bikeshopmenu = document.querySelector(".megamenu_image_bikeshop"); 
let merchmenu = document.querySelector(".megamenu_image_merch"); 

let allmenu = document.querySelector(".megamenu_image_all"); 

let megamenuImages = document.querySelector(".megamenu_images"); 
let megamenuImagesAll = document.querySelectorAll(".megamenu_images"); 

if (ebikelink) {
  ebikelink.addEventListener('mouseover', () => {
    hideMenuImages();
    ebikemenu.style.display = "block";
  });
}

if (escooterlink) {
  escooterlink.addEventListener('mouseover', () => {
    hideMenuImages();
    escootermenu.style.display = "block";
  });
}

if (bikeshoplink) {
  bikeshoplink.addEventListener('mouseover', () => {
    hideMenuImages();
    bikeshopmenu.style.display = "block"; 
  });
}

if (merchlink) {
  merchlink.addEventListener('mouseover', () => {
    hideMenuImages();
    merchmenu.style.display = "block";
  });
}

function hideMenuImages() {
  megamenuImagesAll.forEach((element) => {
    element.style.display = "none";
  });
}
 